<router-outlet></router-outlet>

<!-- global common modal -->
@if ({ modal: modal$ | async }; as vm) {
  <app-common-modal-confirm #modalConfirm [title]="vm.modal?.title" [message]="vm.modal?.message ?? ''"
    [confirmText]="vm.modal?.confirmText" [hasCancel]="vm.modal?.hasCancel" (confirm)="vm.modal?.onConfirm?.()">
  </app-common-modal-confirm>
}

@if ({ toast: toast$ | async }; as vm) {
  <app-common-toast #toastComponent [type]="vm.toast?.type" [subject]="vm.toast?.subject ?? ''" [message]="vm.toast?.message ?? ''"></app-common-toast>
}
